import { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { SF_UI } from './ui/tokens';

type SurfaceCardProps = {
  children: ReactNode;
  className?: string;
  hover?: boolean;
  pad?: boolean;
  /** Animate in when scrolled into view */
  animate?: boolean;
  delay?: number;
  as?: 'div' | 'article' | 'li';
};

/**
 * Shared elevated card surface (rounded-2xl, soft border/shadow) — One World card language.
 */
const SurfaceCard = ({
  children,
  className = '',
  hover = false,
  pad = true,
  animate = true,
  delay = 0,
  as = 'div',
}: SurfaceCardProps) => {
  const classes = `${SF_UI.systemId} ${hover ? SF_UI.surfaceCardHover : SF_UI.surfaceCard} ${
    pad ? SF_UI.surfaceCardPad : ''
  } ${className}`;

  if (!animate) {
    const Tag = as;
    return (
      <Tag className={classes} data-sf-ui="surface-card">
        {children}
      </Tag>
    );
  }

  return (
    <motion.div
      className={classes}
      data-sf-ui="surface-card"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.45, delay }}
    >
      {children}
    </motion.div>
  );
};

export default SurfaceCard;
